// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"235e9535","425":"2ea30071","804":"dba61cc8","877":"e3521d3c"}[chunkId] + ".chunk.js";
};